
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class PasswordRecoverySent extends Vue {
    data() {
      return {
        studio: ''
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
    }
  }
